import { render } from "./ApiUsageContainer.vue?vue&type=template&id=1fedf08e"
import script from "./ApiUsageContainer.vue?vue&type=script&lang=js"
export * from "./ApiUsageContainer.vue?vue&type=script&lang=js"
script.render = render

export default script